export class Subcategory {
    uuid: string;
    categoryUUID: string;
    subcategory: string;
}
